module.exports = __webpack_public_path__ + "static/og-d5e0b515c3bccbe02aad08c2cc8a2555.png";